import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import { AutoComplete } from "antd";
import farmicon from "../../../assests/images/farm.png";
import GmapMultiple from "./GmapMultiple";

const Farmer360Form = (props) => {
  const frmRef = useRef({});
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [farmerId, setfarmerId] = useState(0);
  const [farmerListData, setFarmerListData] = useState([]);
  const [farmerinformationData, setfarmerinformationData] = useState([]);
  const [plotDataList, setplotDataList] = useState([]);
  const [farmer, setfarmer] = useState([]);
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState();
  const [farmerName, setfarmerName] = useState("");
  const [selectedFarmerData, setSelectedFarmerData] = useState([]);
  const [cropwiseAreacovered, setCropwiseAreacovered] = useState([]);
  const [totalLand, settotalLand] = useState(0);
  const [cropsCount, setcropsCount] = useState(0);
  const [coordinate, setcoordinate] = useState([]);
  const [marketCoordinate, setMarketCoordinate] = useState([]);
  const [plotCoordinateList, setPlotCoordinateList] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [selectedPlotDetails, setSelectedPlotDetails] = useState(null);
  const [reportData, setReportData] = useState(null);

  const options = farmerListData?.map((x) => ({
    value: x.farmerId,
    label: `${x.farmerName} (${x.farmerNo})`,
    name: x.farmerName,
    farmerNo: x.farmerNo,
  }));

  const handleSelect = (value, option) => {
    console.log("Selected option:", option);
    const farmerName =
      option?.name && option?.farmerNo
        ? `${option.name} (${option.farmerNo})`
        : option?.name || "";
    setfarmerId(option.value);
    setfarmerName(farmerName);
    getPlotData(farmerId, employeeId, option.value);
  };

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const farmerOnchangedHandler = (Id) => {
    //console.log(event.target.value);
    // console.log("farmerId received:", farmerId);

    setfarmerId(Id);
    var farmerlst = farmerListData.filter((item) => item.farmerId == Id);
    var farmerItem = farmerlst && farmerlst[0];
    if (farmerItem) {
      settotalLand(
        farmerlst[0].plotSizeInHa + " " + farmerlst[0].totalLandUnit
      );
      FarmerDashBoardView(farmerlst[0].farmerId);
      getPlotData(farmerlst[0].farmerId);
      setfarmer(farmerlst);
      fillprocurementData(employeeId);

      // console.log("Selected Farmer:", farmerItem);
      setSelectedFarmerData([farmerItem]);
    } else {
      // console.log("Farmer not found in the list!");
    }
    // console.log("farmerListData:", farmerListData);
  };

  const { sendRequest: getFarmerDashBoardView } = useHttp();

  const FarmerDashBoardView = (farmerId) => {
    getFarmerDashBoardView(
      {
        url: `/api/getFarmerDashBoardView/?farmerId=${farmerId}`,
      },
      (data) => {
        if (data) {
          //console.log("farmerData", data.output);
          setcropsCount(data.output.cropsCount);
        }
      }
    );
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        setEmployeeData(data);
        getFarmersData(0);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getprocurementData } = useHttp();

  const fillprocurementData = (employeeId) => {
    let urlfilter = "";

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    const url = `/api/farmerCropSowingReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        console.log("Report Data:", data);
        setReportData(data); // Set the data to be displayed
      }
    );
  };

  useEffect(() => {
    // fillprocurementData(farmerId);
    // fillprocurementData(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getFarmers } = useHttp();

  const getFarmersData = (empId) => {
    const pdata = { createdBy: empId };
    // farmerSelectListData=[];
    setFarmerListData([]);
    setfarmerinformationData([]);
    // //console.log("empId", empId);
    getFarmers(
      {
        url: `/api/getfarmerDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${empId}`,
      },
      (data) => {
        // console.log("data.farmerDetails", data);

        setFarmerListData(data.output);
      }
    );
  };

  const { sendRequest: getPlot } = useHttp();

  const getPlotData = (farmerId) => {
    const pdata = { createdBy: 5 };

    var markerList = [];
    var PlotCoordinatetempList = [];

    getPlot(
      {
        url: `/api/getfarmerplotDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerId=${farmerId}`,
      },
      (data) => {
        // console.log("data of plot coordinate", data.output);
        var filterplot = data.output;

        //console.log("filterplot", filterplot);
        setplotDataList(filterplot);

        var filterAllCropplot = [];
        var polId = 1;

        filterplot.forEach((item) => {
          var coordinates = {};

          // console.log("cropsDetails", item.cropsDetails);

          var strcrop = JSON.stringify(item.cropsDetails);
          var clist = JSON.parse(JSON.parse(strcrop));
          // console.log("clist", clist);

          clist.forEach((citem) => {
            filterAllCropplot = filterAllCropplot.concat({
              cropName: citem.cropName,
              area: item.plotArea,
            });
          });

          if (item && item.plotCoordinates) {
            var plotCorodinate = [];

            if (item.plotCoordinates.includes('"')) {
              plotCorodinate = JSON.parse(item.plotCoordinates);
            } else {
              plotCorodinate = item.plotCoordinates;
            }

            coordinates = {
              lat: plotCorodinate[0].latitude,
              lng: plotCorodinate[0].longitude,
            };

            var colorcode = "Green";
            var croplist = "";

            markerList = markerList.concat({
              lat: plotCorodinate[0].latitude,
              lng: plotCorodinate[0].longitude,
              tittle: item.farmerName + croplist,
              markeyType: colorcode,
              id: polId,
            });

            var plotNewCoordinates = [];

            plotCorodinate.map((item) => {
              plotNewCoordinates = plotNewCoordinates.concat({
                lat: item.latitude,
                lng: item.longitude,
              });
            });

            // console.log("set color", colorcode);

            PlotCoordinatetempList = PlotCoordinatetempList.concat({
              plotCorodinate: plotNewCoordinates,
              colorCode: colorcode,
              id: "ply" + polId,
            });
          }

          polId = polId + 1;
        });
        setMarketCoordinate([...markerList]);
        setPlotCoordinateList([...PlotCoordinatetempList]);

        if (PlotCoordinatetempList.length > 0) {
          setcoordinate([...PlotCoordinatetempList[0].plotCorodinate]);
        }
        // console.log("set filterAllCropplot", filterAllCropplot);
        loadProcurementDetailcovered(filterAllCropplot);
      }
    );
  };

  useEffect(() => {
    getPlotData();
  }, [getPlot]);

  const loadProcurementDetailcovered = (data) => {
    //console.log("loadProcurementDetailcovered",data)

    if (data && data.length > 0) {
      var tempData = data;

      var croplist = [...new Set(tempData.map((q) => q.cropName))];

      var i = 0;
      var newcropData = [];
      do {
        var selectedcroplist = tempData.filter(
          (item) => item.cropName == croplist[i]
        );

        var totalarea = 0;
        selectedcroplist.forEach((item) => {
          totalarea += parseFloat(item.area || 0);
        });

        var totalplotAreaUnit = "Kg";

        newcropData = newcropData.concat({
          CropName: croplist[i],
          CropArea: totalarea,
        });

        i++;
      } while (croplist.length > i);

      // console.log("cropwiseProcurment 456", newcropData);

      cropwiseAreacovered(newcropData);
    }
  };

  // const CropwiseAreaPieConfig = {
  //   appendPadding: 10,
  //   data:cropwiseAreacovered,
  //   angleField: 'CropArea',
  //   colorField: 'CropName',
  //   radius: 0.75,
  //   label: {
  //     type: 'spider',
  //     labelHeight: 28,
  //     content: '{name}\n{percentage}',
  //   },
  //   interactions: [
  //     {
  //       type: 'element-selected',
  //     },
  //     {
  //       type: 'element-active',
  //     },
  //   ],
  // };

  const handleTabClick = (index) => {
    setActiveTabIndex(index);
    const selectedPlot = plotDataList[index];
    if (selectedPlot && selectedPlot.plotCoordinates) {
      const coordinates = JSON.parse(selectedPlot.plotCoordinates).map(
        (item) => ({
          lat: item.latitude,
          lng: item.longitude,
        })
      );
      setcoordinate(coordinates);
    }
    setSelectedPlotDetails(selectedPlot);
  };
  useEffect(() => {
    // Initialize with the first plot's details if available
    if (plotDataList.length > 0) {
      setSelectedPlotDetails(plotDataList[0]);
    }
  }, [plotDataList]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <h2 className="mx-3 my-1">Farmer Detail</h2>
            </div>
            <div className="row"> &nbsp;</div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>

                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        // console.log("sName", sName);
                      }
                      //   getEmployeeData(sName);
                      setStateName(sName);
                      EmployeeDetail(sName);
                    }}
                  >
                    <option>All State</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          state-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                      getFarmersData(e.target.value);
                      setfarmerName("");
                    }}
                  >
                    <option>Select Employee</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{"Farmer Name"}</label>
                  <AutoComplete
                    options={options}
                    style={{ width: "100%" }}
                    placeholder="--Select Farmer--"
                    value={farmerName}
                    onChange={(value) => setfarmerName(value)}
                    onSelect={handleSelect}
                    filterOption={(inputValue, option) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                  />
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      farmerOnchangedHandler(farmerId ?? 0);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h4>Please select the parameters to get the desired result</h4>
          <hr />
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      {/* Farmer Details Box */}
                      <div className="col-md-12">
                        {selectedFarmerData.length > 0 && (
                          <div className="farmer-detail-box card">
                            <div className="card-header">
                              <h4>Farmer Details</h4>
                            </div>
                            <div className="card-body">
                              <div className="row">
                                <div className="farmer-info-list">
                                  {selectedFarmerData[0] && (
                                    <>
                                      <div>
                                        <strong>Registration Date:</strong>{" "}
                                        {selectedFarmerData[0]
                                          .registrationDate || "N/A"}
                                      </div>
                                      <div>
                                        <strong>Farmer Name:</strong>{" "}
                                        {selectedFarmerData[0].farmerName ||
                                          "N/A"}
                                      </div>
                                      <div>
                                        <strong>Farmer No:</strong>{" "}
                                        {selectedFarmerData[0].farmerNo ||
                                          "N/A"}
                                      </div>
                                      <div>
                                        <strong>Region:</strong>{" "}
                                        {selectedFarmerData[0].regionName ||
                                          "N/A"}
                                      </div>
                                      <div>
                                        <strong>Area:</strong>{" "}
                                        {selectedFarmerData[0].areaName ||
                                          "N/A"}
                                      </div>
                                    </>
                                  )}
                                </div>
                                <ul className="farmer-info-list">
                                  {selectedFarmerData[0] && (
                                    <>
                                      <div>
                                        <strong>Village Name:</strong>{" "}
                                        {selectedFarmerData[0].villageName ||
                                          "N/A"}
                                      </div>
                                      <div>
                                        <strong>LGA:</strong>{" "}
                                        {selectedFarmerData[0].lga || "N/A"}
                                      </div>
                                      <div>
                                        <strong>Address:</strong>{" "}
                                        {selectedFarmerData[0].address || "N/A"}
                                      </div>
                                      <div>
                                        <strong>City:</strong>{" "}
                                        {selectedFarmerData[0].city || "N/A"}
                                      </div>
                                      <div>
                                        <strong>State:</strong>{" "}
                                        {selectedFarmerData[0].state || "N/A"}
                                      </div>
                                    </>
                                  )}
                                </ul>
                                <ul className="farmer-info-list">
                                  {selectedFarmerData[0] && (
                                    <>
                                      <div>
                                        <strong>Account Holder Name:</strong>{" "}
                                        {selectedFarmerData[0]
                                          .accountHolderName || "N/A"}
                                      </div>
                                      <div>
                                        <strong>Bank Name:</strong>{" "}
                                        {selectedFarmerData[0].bankName ||
                                          "N/A"}
                                      </div>
                                      <div>
                                        <strong>Account Type:</strong>{" "}
                                        {selectedFarmerData[0].accountType ||
                                          "N/A"}
                                      </div>
                                      <div>
                                        <strong>Account Number:</strong>{" "}
                                        {selectedFarmerData[0].accountNumber ||
                                          "N/A"}
                                      </div>
                                      <div>
                                        <strong>BVN:</strong>{" "}
                                        {selectedFarmerData[0].bvn || "N/A"}
                                      </div>
                                    </>
                                  )}
                                </ul>
                                <ul className="farmer-info-list">
                                  {selectedFarmerData[0] && (
                                    <>
                                      <div>
                                        <strong>Category:</strong>{" "}
                                        {selectedFarmerData[0].category ||
                                          "N/A"}
                                      </div>
                                      <div>
                                        <strong>Gender:</strong>{" "}
                                        {selectedFarmerData[0].gender || "N/A"}
                                      </div>
                                      <div>
                                        <strong>DOB:</strong>{" "}
                                        {selectedFarmerData[0].dob || "N/A"}
                                      </div>
                                      <div>
                                        <strong>Mobile:</strong>{" "}
                                        {selectedFarmerData[0].mobile || "N/A"}
                                      </div>
                                    </>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 col-sm-6 col-12">
                        <div className="info-box">
                          <span className="info-box-icon bg-info">
                            <img
                              src={farmicon}
                              height="30"
                              width="30"
                              style={{ opacity: ".8" }}
                            />
                          </span>

                          <div className="info-box-content">
                            <span className="info-box-text">Field</span>
                            <span className="info-box-number">{totalLand}</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3 col-sm-6 col-12">
                        <div className="info-box">
                          <span className="info-box-icon bg-info">
                            <i className="fas fa-seedling"></i>
                          </span>

                          <div className="info-box-content">
                            <span className="info-box-text">Crops</span>
                            <span className="info-box-number">
                              {cropsCount}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-header p-2">
                      <ul className="nav nav-pills">
                        {Array.isArray(plotDataList) &&
                        plotDataList.length > 0 ? (
                          plotDataList.map((plot, index) => (
                            <div key={plot.plotId} className="nav-item">
                              <a
                                className={`nav-link ${
                                  index === activeTabIndex ? "active" : ""
                                }`}
                                href="#!"
                                onClick={() => handleTabClick(index)}
                              >
                                Plot {plot.plotName}
                              </a>
                            </div>
                          ))
                        ) : (
                          <p>No Plots Available</p>
                        )}
                      </ul>
                    </div>

                    <div className="row">
                      <div className="col-md">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-map mr-1"></i>
                              Map
                            </h3>
                            <div className="card-tools"></div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">
                              <div
                                className="chart tab-pane active"
                                id="revenue-chart"
                              >
                                <GmapMultiple
                                  coordinate={coordinate}
                                  marketCoordinate={marketCoordinate}
                                  plotCoordinateList={plotCoordinateList}
                                  mapzoom={19}
                                />
                              </div>
                              <div
                                className="chart tab-pane"
                                id="sales-chart"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-chart-pie mr-1"></i>
                              Plot Detail
                            </h3>
                            <div className="card-tools"></div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">
                              <div className="plot-detail">
                                {selectedPlotDetails ? (
                                  <>
                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className="plot-item">
                                          <strong>Plot Name:</strong>{" "}
                                          {selectedPlotDetails.plotName}
                                        </div>
                                        <div className="plot-item">
                                          <strong>Area:</strong>{" "}
                                          {selectedPlotDetails.plotArea}{" "}
                                          {selectedPlotDetails.plotAreaUnit}
                                        </div>
                                        <div className="plot-item">
                                          <strong>Mapping Date:</strong>{" "}
                                          {selectedPlotDetails.mappingDate}
                                        </div>
                                        <div className="plot-item">
                                          <strong>Land Mark:</strong>{" "}
                                          {selectedPlotDetails.landMark}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="plot-item">
                                          <strong>Land Ownership:</strong>{" "}
                                          {selectedPlotDetails.landOwnership}
                                        </div>
                                        <div className="plot-item">
                                          <strong>Farm Location:</strong>{" "}
                                          {selectedPlotDetails.farmLocation}
                                        </div>
                                        <div className="plot-item">
                                          <strong>
                                            Land Preparation Type:
                                          </strong>{" "}
                                          {
                                            selectedPlotDetails.landPreparationType
                                          }
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="plot-item">
                                          <strong>Soil Type:</strong>{" "}
                                          {selectedPlotDetails.soilType}
                                        </div>
                                        <div className="plot-item">
                                          <strong>Soil Texture:</strong>{" "}
                                          {selectedPlotDetails.soilTexture}
                                        </div>
                                        <div className="plot-item">
                                          <strong>Irrigation Source:</strong>{" "}
                                          {selectedPlotDetails.irrigationSource}
                                        </div>
                                      </div>
                                    </div>

                                    <div style={{ marginTop: "10px" }}>
                                      <h6>Plot Photos:</h6>
                                      <div className="plot-photos">
                                        {selectedPlotDetails.plotPhotosUrls ? (
                                          JSON.parse(
                                            selectedPlotDetails.plotPhotosUrls
                                          ).map((photoUrl, index) => {
                                            const fullUrl = `${process.env.REACT_APP_FILE_URL}${photoUrl}`;

                                            return (
                                              <img
                                                key={index}
                                                src={fullUrl}
                                                alt={`Plot Photo ${index + 1}`}
                                                style={{
                                                  width: "150px",
                                                  height: "150px",
                                                  marginBottom: "10px",
                                                  marginRight: "10px",
                                                  borderRadius: "5px",
                                                }}
                                                onError={(e) => {
                                                  e.target.style.display =
                                                    "none";
                                                }}
                                              />
                                            );
                                          })
                                        ) : (
                                          <div>No Photos Available</div>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <div>No Plot Selected</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">
                              <i className="fas fa-chart-pie mr-1"></i>
                              Date Wise Activity
                            </h3>
                            <div className="card-tools"></div>
                          </div>
                          <div className="card-body">
                            <div className="tab-content p-0">
                              <table
                                className="table table-bordered text-center table-responsive"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  <tr>
                                    <th>Farmer Name</th>
                                    <th>plot Name</th>
                                    <th>Sowing Date</th>
                                    <th>Irrigation Date</th>
                                    <th>Land Preparation Type</th>
                                    <th>Field Operation Date</th>
                                    <th>Plant Count</th>
                                    <th>Transplanted Area</th>
                                    <th>Field Operation Description</th>
                                    <th>Sowing Method</th>
                                    <th>Seed Source</th>
                                    <th>Estimated Yield(kg)</th>
                                    <th>Estimated Yield(tonne)</th>
                                    <th>Latitude</th>
                                    <th>Longitude</th>
                                    <th>Created Date</th>
                                    {/* Add more headers based on your report data */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {/* Filter and display only the data for the selected farmer */}
                                  {reportData && reportData.length > 0 ? (
                                    reportData
                                      .filter((item) => {
                                        const isPlotNameMatch =
                                          item.plotName ===
                                          selectedPlotDetails?.plotName;

                                        // Match farmerName
                                        const isFarmerNameMatch =
                                          item.farmerName &&
                                          item.farmerName.toLowerCase() ===
                                            farmerName.toLowerCase();

                                        // Match plot coordinates (optional if plotName is unique)
                                        // const isCoordinateMatch =
                                        //   item.entryLatLong &&
                                        //   JSON.stringify(
                                        //     item.plotCoordinates
                                        //   ) ===
                                        //     JSON.stringify(
                                        //       selectedPlotDetails?.coordinates
                                        //     );

                                        return (
                                          isPlotNameMatch && isFarmerNameMatch
                                          // isCoordinateMatch
                                        );
                                      })
                                      .map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.farmerName}</td>
                                          <td>{item.plotName}</td>
                                          <td>
                                            {new Date(
                                              item.fieldOperationDate
                                            ).toLocaleDateString()}
                                          </td>
                                          <td>
                                            {new Date(
                                              item.irrigationDate
                                            ).toLocaleDateString()}
                                          </td>
                                          <td>{item.landPreparationType}</td>
                                          <td>
                                            {new Date(
                                              item.fieldOperationDate
                                            ).toLocaleDateString()}
                                          </td>
                                          <td>{item.plantCount}</td>
                                          <td>{item.transplantedArea}</td>
                                          <td>
                                            {item.fieldOperationDescription}
                                          </td>
                                          <td>{item.sowingMethod}</td>
                                          <td>{item.seedSource}</td>
                                          <td>{item.estimateYield}</td>
                                          <td>
                                            {(
                                              item.estimateYield / 1000
                                            ).toFixed(2)}
                                          </td>
                                          <td>
                                            {item.entryLatLong &&
                                              (() => {
                                                const coord = JSON.parse(
                                                  item.entryLatLong
                                                );
                                                return (
                                                  <div>{coord.latitude}</div>
                                                );
                                              })()}
                                          </td>
                                          <td>
                                            {item.entryLatLong &&
                                              (() => {
                                                const coord = JSON.parse(
                                                  item.entryLatLong
                                                );
                                                return (
                                                  <div>{coord.longitude}</div>
                                                );
                                              })()}
                                          </td>
                                          <td>
                                            {new Date(
                                              item.createdDate
                                            ).toLocaleDateString()}
                                          </td>
                                        </tr>
                                      ))
                                  ) : (
                                    <tr>
                                      <td colSpan="14">No data available</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Farmer360Form;
